import { render } from "./medicalNumDialog.vue?vue&type=template&id=55dff2b3&scoped=true"
import script from "./medicalNumDialog.vue?vue&type=script&lang=js"
export * from "./medicalNumDialog.vue?vue&type=script&lang=js"

import "./medicalNumDialog.vue?vue&type=style&index=0&id=55dff2b3&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dff2b3"]])

export default __exports__